import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule as PrimengTabsModule } from 'primeng/tabs';
import { TabsComponent } from './components/tabs/tabs.component';
import { TabComponent } from './components/tab/tab.component';

@NgModule({
  declarations: [TabsComponent, TabComponent],
  imports: [CommonModule, PrimengTabsModule],
  exports: [TabsComponent, TabComponent],
})
export class TabsModule {}
